<section class="pt-navigation-context">
    <dls-tabs class="pt-primary-navigation">
        <a *ngFor="let tabs of tabsTitles$ | async" (click)="onTabChanged(tabs.name)"
           class="{{cssClassFormat(tabs.name)}}"
           [ngClass]="{'pt-selected':tabs.name === selectedTab}">
            <span>{{tabs.name | translate}}</span>
        </a>
    </dls-tabs>
</section>

